module.exports = __webpack_public_path__ + "static/media/AMEX.bbf05ce7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/AMEX.svg
// module id = 74
// module chunks = 0